import 'whatwg-fetch';
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import store from './apps/shared/store';
import ipApps from './apps/ip';
import barselApps from './apps/barselsfonden';

Vue.use(VeeValidate, {
    aria: true,
    classNames: {},
    classes: false,
    delay: 0,
    dictionary: null,
    errorBagName: 'errors',
    events: 'blur',
    fieldsBagName: 'fields',
    fastExit: true,
    i18n: null,
    i18nRootKey: 'validations',
    inject: true,
    locale: 'da',
    validity: false,
    useConstraintAttrs: true
});

new Vue({
    name: 'IP-Root',
    store,
    components: {
        ipDataGrid: () => import('./apps/shared/components/datagrid/datagrid.vue'),
        ...ipApps,
        ...barselApps
    },
    mounted: function() {
        this.$store.dispatch('setUrl', this.$el.getAttribute('data-urls'));
    }
}).$mount('#vue-root');
